import React from 'react'
import { ApiTableColumn } from '@e3dc-react/shell/Elements/ApiView/ApiView'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useTheme } from '@mui/material'
import { getFullName } from 'src/Libs/utils/string-functions'
import { UseFetchProps } from '@e3dc-react/shell/Hooks/useFetch'
import { J2Multiply, J2Validate } from '@e3dc-react/icons'
import { FetchedUserDataConnected } from 'src/Libs/user/models/user.model'
import { LinkButton } from '@e3dc-react/shell/Elements/Buttons'

export const useUserTableData = (): {
  fetchProps: UseFetchProps
  columns: ApiTableColumn<FetchedUserDataConnected>[]
} => {
  const { t } = useCustomTranslation()
  const theme = useTheme()

  const fetchProps: UseFetchProps = {
    url: 'users',
    endpoint: process.env.REACT_APP_API_ENDPOINT,
    connect: 'location,company,shopPermission',
  }

  const columns: ApiTableColumn<FetchedUserDataConnected>[] = [
    {
      name: 'user.username',
      label: t('common.username'),
      value: item => (
        <LinkButton
          hasUnderline={false}
          linkColor={theme.palette.primary.main}
          content={<>{item['user.username']}</>}
          link={`/overview/users/${item['user.ID']}`}
        />
      ),
    },
    {
      name: 'user.Name',
      label: t('common.name'),
      value: item => getFullName(item['user.Vorname'], item['user.Name']),
    },
    {
      name: 'location.Email',
      label: t('common.email'),
      value: item => item['location.Email'],
    },
    {
      name: 'location.Telefon',
      label: t('common.phone'),
      value: item => item['location.Telefon'],
    },
    {
      name: 'user.level',
      label: t('common.userLevel'),
      value: item => t(`framework.userBadge.userlevel.${item['user.level']}`),
    },
    {
      name: 'company.Name',
      label: t('common.company'),
      value: item =>
        item['company.Name'] && (
          <LinkButton
            hasUnderline={false}
            linkColor={theme.palette.primary.main}
            content={<>{item['company.Name']}</>}
            link={`/overview/companies/${item['company.ID']}`}
          />
        ),
    },
    {
      name: 'user.source',
      label: t('common.type'),
      value: item => (item['user.ssoId'] && item['user.source'] === 'hager' ? t('administration.users.hager') : t('administration.users.e3dc')),
    },
    {
      name: 'user.ipin',
      label: t('common.ipin'),
      value: item => item['user.ipin'],
    },
    {
      name: 'permissions.permission',
      label: t('user.company.user.hasShop'),
      value: item => {
        return item['permissions.permission']?.includes('useShop') ? (
          <J2Validate sx={{ color: 'success.main' }} />
        ) : (
          <J2Multiply sx={{ color: 'error.main' }} />
        )
      },
    },
    {
      name: 'user.mailNotification',
      label: t('user.userData.emailNotification'),
      value: item => {
        return item['user.mailNotification'] ? <J2Validate sx={{ color: 'success.main' }} /> : <J2Multiply sx={{ color: 'error.main' }} />
      },
      sortable: false,
    },
  ]

  return { fetchProps, columns }
}
